import { createContext, useContext } from 'react';

import type { PartnerLookupContextValue } from 'components/partner_lookup/PartnerLookupWidget';

export const PartnerLookupContext = createContext({} as PartnerLookupContextValue);
PartnerLookupContext.displayName = 'PartnerLookupContext';

export const usePartnerLookup = () => useContext(PartnerLookupContext);